import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface FeatureFlagDetails {
  uid: string;
  is_active: boolean;
}

type FeatureFlagDetailsResponse = FeatureFlagDetails | null;

const useGetFeatureFlag = (flagName: string, interviewUid?: string) => {
  const body = {
    interview: interviewUid,
    flag_name: flagName,
  };

  const { data, isLoading, isError } = useQuery<
    FeatureFlagDetailsResponse,
    Error
  >(
    ['getFeatureFlagDetails', interviewUid],
    async () =>
      fetchWithCsrfToken<FeatureFlagDetailsResponse>(
        `${PrependUrl.ASYNC}/assessment/get_feature_flag`,
        'POST',
        body
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
    isError,
  };
};

export default useGetFeatureFlag;
